/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import {Trans} from 'react-i18next';

const PREFIX = 'HEADER';

const classes = {
  title: `${PREFIX}-title`,
  subtitle: `${PREFIX}-subtitle`,
  videoWrapper: `${PREFIX}-videoWrapper`,
  videoTitle: `${PREFIX}-videoTitle`,
};

const StyledBox = styled(Box)(() => ({
  [`& .${classes.title}`]: {
    color: '#F1F1F1',
    fontSize: '32px',
    fontWeight: 300,
    lineHeight: '40px',
  },
}));

const WizardHeader = () => {
  return (
    <StyledBox>
      <Typography className={classes.title}>
        <Trans>Добро пожаловать</Trans>
      </Typography>
    </StyledBox>
  );
};

export default WizardHeader;
